export const milestones=[
    // {
    //     'year':'2023',
    //     'achieve':''
    // },
    {
        'year':'2025',
        'achieve':'New UG Programme - B.Tech Information Technology (IT) is established by Government of Tamil Nadu with the intake of 60 students.'
    },
    {
        'year':'2025',
        'achieve':'Establishment of Alagappa Incubation Forum (Section 8 Company).'
    },
    {
        'year':'2024',
        'achieve':'NBA accredition of 3 programs namely B.E Civil Engineering, B.E Electrical and Electronics Engineering and B.E Mechanical Engineering for 3 years'
    },
    {
        'year':'2022',
        'achieve':'Centres of Excellence in Antenna Testing & Electronics Test Engineering worth 1 crore.'
    },
    {
        'year':'2021',
        'achieve':'NBA accredition of 3 programs namely B.E Civil Engineering, B.E Mechanical Engineering and B.E Electrical and Electronics Engineering'
    },
    {
        'year':'2020',
        'achieve':'Accredited by NAAC with B++ Grade.'
    },
    {
        'year':'2019',
        'achieve':'Rs.1.00 Crores was sanctioned for the establishment of Centre of Excellence in Smart Manufacturing (Mechanical).'
    },
    {
        'year':'2019',
        'achieve':'IOT Lab was Established as Centre of Excellence worth 30 Lakhs Supported by Alumni.'
    },
    {
        'year':'2017',
        'achieve':'Rs.7.00 Crore was funded under TEQIP -III'
    },
    {
        'year':'2016',
        'achieve':'The recognized QIP center of AICTE.'
    },
    {
        'year':'2016',
        'achieve':'Rs. 5 Crores was additionally sanctioned under TEQIP-II based on best performance in TEQIP activities.'
    },
    {
        'year':'2015',
        'achieve':'Dr.Abdul Kalam Hostel was inaugurated by then Honorable Chief Minister.'
    },
    {
        'year':'2014',
        'achieve':'E-Yantra Centre was established with the support of IIT-Mumbai'
    },
    {
        'year':'2014',
        'achieve':'U.G and PG Programs are Permanently Affiliated by Anna University.'
    },
    {
        'year':'2012',
        'achieve':'Rs.12.5 Crore was funded under TEQIP-II to scale up P.G Programs.'
    },
    {
        'year':'2010',
        'achieve':'Institution Autonomous Status conferred by UGC'
    },
    {
        'year':'2008',
        'achieve':'Best Engineering College Award by Government of Tamilnadu.'
    },
    {
        'year':'2006',
        'achieve':'Rs.15.5 Crore was funded under TEQIP-I to scale up U.G Programs and Infrastructure Development.'
    },
    {
        'year':'2001',
        'achieve':'B.E. Computer Science and Engineering discipline was started.'
    },
    {
        'year':'1971',
        'achieve':'Part-Time B.E. Programs Civil Engineering, Mechanical Engineering, Electrical and Electronics Engineering disciplines were introduced.'
    },
    {
        'year':'1969',
        'achieve':'Electronics and Communication Engineering discipline was started.'
    },
    {
        'year':'1966',
        'achieve':'Institution was handed over to Government of TamilNadu.'
    },
    {
        'year':'1952',
        'achieve':'Alagappa Chettiar College of Engineering and Technology (ACCET) was started with Civil, Mechanical and Electrical Engineering (3 disciplines).'
    }
    
    
]